import { PAGINATION_CONSTANTS } from './constants';

export const POSTS_PER_PAGE = PAGINATION_CONSTANTS.DEFAULT_POSTS_PER_PAGE;
